import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { Chip } from '@pets-ui/Chip/Chip'
import style from './Searcher.module.scss'

interface SearcherPopKeywordDisplayProps {
  setUserInputFieldTextAndSearch: (keyword: string) => void
}

const SearcherPopKeywordDisplay = ({
  setUserInputFieldTextAndSearch,
}: SearcherPopKeywordDisplayProps) => {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: exhibitorSettings } = useApiCampaignActivityInfo(campaignCodeFromUrl)
  const { search_keywords: searchKeywords } = exhibitorSettings || {}
  return (
    <section>
      <h3 className={style.title}>熱門搜尋</h3>
      <div className={style['keywords-with-gap']}>
        {searchKeywords?.map((keyword) => {
          return (
            <Chip
              key={keyword}
              // TODO: 需要改成用 stylex 的 variant 來處理，等 UI/UX 更新
              className={style['pop-keyword']}
              onClick={() => {
                setUserInputFieldTextAndSearch(keyword)
              }}
            >
              {keyword}
            </Chip>
          )
        })}
      </div>
    </section>
  )
}

export default SearcherPopKeywordDisplay
